"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.client = void 0;
const axios_1 = __importDefault(require("axios"));
const config_1 = __importDefault(require("@src/config"));
const mergeWith_1 = __importDefault(require("lodash/mergeWith"));
const camelCase_1 = __importDefault(require("lodash/camelCase"));
const snakeCase_1 = __importDefault(require("lodash/snakeCase"));
const transformCasing_1 = require("./transformCasing");
const client = axios_1.default.create({
    baseURL: config_1.default.api,
    withCredentials: true,
    headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
    },
});
exports.client = client;
client.interceptors.response.use((response) => {
    const { data } = response;
    if (data && typeof data === 'object' && data) {
        const mergedData = (0, mergeWith_1.default)((0, transformCasing_1.transformCasing)(data, snakeCase_1.default), (0, transformCasing_1.transformCasing)(data, camelCase_1.default));
        return { ...response, data: mergedData };
    }
    return response;
}, error => {
    return Promise.reject(error);
});
